import { Divider, Grid } from '@material-ui/core'
import styled from 'styled-components'

export const ModalTitle = styled.p`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 2rem;
  font-weight: 400;
`

export const Wrapper = styled(Grid)`
  margin-bottom: 0.5rem;
  overflow-y: scroll;
  height: 700px;
`

export const Fieldset = styled(Grid)`
  margin-bottom: 1rem 0 1rem 0;
`

export const FullGrid = styled(Grid)`
  padding: 1rem;
`

export const GridHeader = styled(Grid)`
  display: inline-flexbox;
  padding: 0.5rem 0 0 0;
`

export const GridTitle = styled(Grid)`
  display: block;
  padding: 0.5rem 0 0 0;
`

export const BoxTitle = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 1.4rem;
  font-weight: 400;
  padding-bottom: 0;
  margin: 0 0 0.8rem 0.5rem;
`

export const GridFields = styled(Grid)`
  display: flex;
  flex-direction: row;
`

export const GridFieldsPhoto = styled(Grid)`
  display: flex;
  margin: 0;
  flex-direction: row;
`

export const GridPhoto = styled(Grid)`
  display: flex;
  margin: 0 1.6rem;
  width: calc(100% + 24px);
  flex-direction: row;
`

export const GridInput = styled(Grid)``

export const CardPhoto = styled.div`
  background-color: #f7f9fd;
  border-radius: 0.8rem;
  width: 100%;
  margin: 0 1.6rem;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0.8rem;
`

export const DividerVertical = styled(Divider)`
  background-color: #f2f3f7;
`
